// extracted by mini-css-extract-plugin
export var chatHtmlText = "_m5-2";
export var chatLink = "_m5-0";
export var chatText = "_m5-1";